<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <mat-progress-bar mode="indeterminate" [hidden]="!loading" class="detaile"></mat-progress-bar>
    <span>
        <span>انتخاب قطعه</span>
    </span>
    <span (click)="close()">
        <mat-icon class="close">close</mat-icon>
    </span>
</div>

<form [formGroup]="form1">
    <div mat-dialog-content class="matDialogContent">
        <div class="row pe1">
            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="material" class='wh-label'>
                    <span *ngIf="lang == 1"> نام کالا: </span>
                    <span *ngIf="lang == 2"> Material Name : </span>
                    <span (click)="reset_input(171)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="material_title" (click)="load_services(171) " readonly>
                    <input class="wh-input" formControlName="material" [hidden]="true" readonly>
                </label>
            </div>

            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="material" class='wh-label'>
                    <span *ngIf="lang == 1"> نام طرف حساب: </span>
                    <span *ngIf="lang == 2"> ---- : </span>
                    <span (click)="reset_input(24)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="user_title" (click)="load_services(24) " readonly>
                    <input class="wh-input" formControlName="user" [hidden]="true" readonly>
                </label>
            </div>

            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="customer" class='wh-label'>
                    <span *ngIf="lang == 1"> از تاریخ : </span>
                    <span *ngIf="lang == 2"> Date1 : </span>
                    <input class="wh-input" matInput [matDatepicker]="picker" formControlName="date1"
                        autocomplete="off">
                    <mat-datepicker-toggle matSuffix [for]="picker" class="datepicker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </label>
            </div>

            <div class='col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="customer" class='wh-label'>
                    <span *ngIf="lang == 1"> تا تاریخ : </span>
                    <span *ngIf="lang == 2"> Date1 : </span>
                    <input class="wh-input" matInput [matDatepicker]="picker2" formControlName="date2"
                        autocomplete="off">
                    <mat-datepicker-toggle matSuffix [for]="picker2" class="datepicker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                </label>
            </div>

        </div>
    </div>

    <div mat-dialog-actions class="matDialogActions">
        <button type="button" class="btn_pe" [ngClass]="{btn_en:lang == 2}" (click)="search(1)">
            <span>مشاهده ریز کالا</span>
        </button>
        <button type="button" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="ref != 'home'" (click)="search(2)">
            <span *ngIf="lang == 2">Excel</span>
            <span *ngIf="lang == 1">خروجی اکسل</span>
        </button>
    </div>
</form>